<template>
    <div class="form-check form-check-inline">
        <input
            :id="id"
            v-model="isChecked"
            class="form-check-input"
            type="checkbox"
            :value="value"
            v-bind="$attrs"
            @change="$emit('change', $event)"
        >
        <label class="form-check-label task__item__label cursor-pointer" :for="id" :class="[labelClass, `text--${size}`]"> 
            <slot />
        </label>
    </div>
</template>

<script>
import { simpleUniqueID } from "@/utils/strings";
/**
 * @group UI Components / Forms
 * A basic checkbox implementation with the default styling and label
 * <br>
 * ![image](https://cdn.filestackcontent.com/baI9CUMSfe0JrgTfYIr1)

 * <h2>Example</h2>
 * `<BaseCheckbox value="future" v-model="myValue">Save for the future</BaseCheckbox>`
 * `<BaseCheckbox value="option1" :values.sync="myArray">Option 1</BaseCheckbox>`
 */
export default {
    model: {
        event: "checked",
        prop: "values",
    },

    props: {
        id: {
            type: String,
            default: () => `checkbox-${simpleUniqueID()}`, // Generate a default unique ID
        },
        
        size: { 
            type: String, 
            default: "sm",
            validator: (value) => {
                return ["xs", "sm", "md", "lg"].includes(value);
            },
        },

        // Define the checkbox value. Same as with normal checkbox input.
        value: {
            type: [String, Number, Boolean, null, undefined],
            default: null,
        },

        // Define a class or classes for the checkbox label
        labelClass: {
            type: String,
            default: undefined,
        },

        // Defines a list of currently selected or checked items for group scenarios.
        values: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        isChecked: {
            get() {
                if (Array.isArray(this.values)) {
                    return this.values.includes(this.value);
                }
                return !!this.values; // Handle boolean v-model
            },
            set(newValue) {
                let newValues; // array or boolean
                
                
                if (Array.isArray(this.values)) {
                    if (newValue) {     // checked is true                   
                        newValues = [...this.values, this.value];
                        
                        // Ensure uniqueness if needed
                        newValues = [...new Set(newValues)];
                    } else { // checked is false
                        newValues = this.values.filter((val) => val !== this.value);
                    }
                } else {
                    newValues = newValue;
                }
                this.$emit("checked", newValues);
            },
        },
    },
};
</script>